import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {HinweisboxTypeEnum} from '../../../../shared/components/hinweisbox/hinweisbox-type.enum';
import {HinweisboxComponent} from '../../../../shared/components/hinweisbox/hinweisbox.component';
import {I18NextPipe} from '@kokos-i18next';
import {LinkOutComponent} from '../../../../shared/components/structure/link-out/link-out.component';
import {SectionComponent} from '../../../../shared/components/structure/section/section.component';
import {Subanliegen} from '../../../../core/model/anliegen';
import {DienststellenArtEnum} from '../../../../core/model/dienststellen-art.enum';
import {Dienststelle} from '../../../../core/model/dienststelle';

@Component({
    selector: 'kokos-hinweise',
    imports: [HinweisboxComponent, I18NextPipe, LinkOutComponent, SectionComponent],
    templateUrl: './hinweise.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class HinweiseComponent {
    @Input() subanliegen: Subanliegen | null;
    @Input() dienststelle: Dienststelle | null;
    @Input() anliegenEmpty: boolean;

    readonly HinweisboxTypeEnum = HinweisboxTypeEnum;

    get showAnliegen(): boolean {
        return !this.anliegenEmpty && !!this.dienststelle?.teilnehmend;
    }

    get hasHinweise(): boolean {
        return this.hasSubanliegenHinweis || this.hasSubanliegenLink || this.jobcenterZKTNotActive || this.jobcenterGeNotActive;
    }

    get hasSubanliegenHinweis(): boolean {
        return !!this.subanliegen?.hinweis;
    }

    get hasSubanliegenLink(): boolean {
        return !!this.subanliegen?.link && !!this.subanliegen?.linkText;
    }

    get jobcenterZKTNotActive(): boolean {
        return !!this.dienststelle && this.dienststelle.dienststellenArt === DienststellenArtEnum.ZKT && !this.showAnliegen;
    }

    get jobcenterGeNotActive(): boolean {
        return !!this.dienststelle && this.dienststelle.dienststellenArt === DienststellenArtEnum.GE && !this.showAnliegen;
    }

}